export default __webpack_public_path__ + "static/media/Corner avoidance drill.1aef2b7b.jpg";